export enum Action {
  delete = 'delete',
  edit = 'edit',
  add = 'add',
  navigate = 'navigate',
  passwordReset = 'passwordReset'
}
